// Screen/HelloWorld.js
import { useEffect, useRef } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Home from "./Screen/Home";
import Features from "./Screen/Features";
import AboutUs from "./Screen/AboutUs";
import ContactUs from "./Screen/ContactUs";
import Hospitality from "./Screen/Hospitality";
import Retail from "./Screen/Retail";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import PrivacyPolicy from "./Screen/PrivacyPolicy";
import TermsOfService from "./Screen/TermsOfService";

import { CurrencyProvider } from "./context/CurrencyContext";

function App() {
  const featuresRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    if (document.getElementById("tawkto-script")) return; // Prevent duplicate script

    var s1 = document.createElement("script");
    s1.id = "tawkto-script";
    s1.async = true;
    s1.src = "https://embed.tawk.to/686757aa72d8cc190db098a7/1iv9qvnt4";
    s1.charset = "UTF-8";
    s1.setAttribute("crossorigin", "*");
    document.body.appendChild(s1);

    // Optional cleanup if Footer unmounts
    return () => {
      if (s1.parentNode) {
        s1.parentNode.removeChild(s1);
      }
    };
  }, []);

  useEffect(() => {
    // Map routes to titles
    const routeTitles = {
      "/": "Home | SnapPoss",
      "/features": "Features | SnapPoss",
      "/hospitality": "Hospitality | SnapPoss",
      "/retail": "Retail | SnapPoss",
      "/about": "About Us | SnapPoss",
      "/contact": "Contact Us | SnapPoss",
      "/privacy-policy": "Privacy Policy | SnapPoss",
      "/terms-of-service": "Terms of Service | SnapPoss",
    };
    document.title = routeTitles[location.pathname] || "SnapPoss";
  }, [location]);

  // Handler to scroll to Features
  const scrollToFeatures = () => {
    if (featuresRef.current) {
      featuresRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <CurrencyProvider>
      <Navbar onFeaturesClick={scrollToFeatures} />
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <Home
              onFeaturesRef={(ref) => (featuresRef.current = ref.current)}
            />
          }
        />
        <Route path="/features" element={<Features />} />
        <Route path="/hospitality" element={<Hospitality />} />
        <Route path="/retail" element={<Retail />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
      </Routes>
      <Footer />
    </CurrencyProvider>
  );
}

export default App;
